import { useQuery } from "react-query";
import AvailableTranslationCacheName from "../../utils/AvailableTranslationCacheName";
import { fetchAvailableTranslations } from "../../api/availableTranslation";

export const useAvailableTranslation = () => {
  return useQuery({
    queryKey: [AvailableTranslationCacheName.getAvailableTranslation()],
    queryFn: fetchAvailableTranslations,
    refetchOnMount: true,
  });
};
